import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(koreanDateString: string): string {
  const match = koreanDateString.match(
    /(\d{4})\.\s*(\d{1,2})\.\s*(\d{1,2})\.\s*(오전|오후|AM|PM)\s*(\d{1,2}):(\d{2}):(\d{2})/i
  )

  if (!match) {
    throw new Error("Invalid Korean date format")
  }

  const [, year, month, day, meridiem, hour, minute, second] = match
  const normalizedMeridiem = meridiem.toUpperCase()

  let adjustedHour = parseInt(hour, 10)
  if ((meridiem === "오후" || normalizedMeridiem === "PM") && adjustedHour !== 12) {
    adjustedHour += 12
  } else if ((meridiem === "오전" || normalizedMeridiem === "AM") && adjustedHour === 12) {
    adjustedHour = 0
  }

  const paddedMonth = month.padStart(2, "0")
  const paddedDay = day.padStart(2, "0")
  const paddedHour = adjustedHour.toString().padStart(2, "0")

  return `${year}-${paddedMonth}-${paddedDay} ${paddedHour}:${minute}:${second}`
}
